import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["emoji-button", { 'text-primary emoji-button--active': _ctx.active }])
  }, [
    _createElementVNode("span", {
      style: _normalizeStyle(_ctx.emojiStyle)
    }, _toDisplayString(_ctx.emoji), 5),
    _createElementVNode("span", {
      style: _normalizeStyle(_ctx.countStyle),
      class: "text-gray-500"
    }, _toDisplayString(_ctx.count), 5)
  ], 2))
}